import { grey } from '@mui/material/colors';

export const headerStyles = {
  appBar: {
    bgcolor: '#3f51b5',
    color: '#fff',
  },
  toolbar: {
    width: '100%',
  },
  title: {
    flexGrow: 1,
  },
  logoutButton: {
    '&:hover': {
      bgcolor: '#303f9f',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)',
      transform: 'scale(1.05)',
      transition: 'all 0.3s ease-in-out',
    },
  },
};

export const containerStyles = {
  box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    p: 4,
    mt: 4,
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%',
    maxWidth: '600px',
    minHeight: 200,
    bgcolor: '#ffffff',
    borderRadius: 2,
    boxShadow: 3,
    textAlign: 'center',
    p: 4,
  },
  button: {
    bgcolor: '#3f51b5',
    color: '#fff',
    '&:hover': { bgcolor: '#303f9f' },
    padding: '12px 24px',
    minWidth: '200px',
    height: '40px',
  },
};

export const generalStyles = {
  pageBox: {
    minHeight: '100vh',
    bgcolor: '#f4f4f4',
    display: 'flex',
    flexDirection: 'column',
  },
};
